import { Button, Image } from '@mantine/core';
import type { TranslateFn } from '@newo/localization';

type TCheckYourPhoneModal = {
	handleClose: () => void;
	translate: TranslateFn;
};

const CheckYourPhone = function CheckYourPhone({
	handleClose,
	translate
}: TCheckYourPhoneModal) {
	return (
		<div className="flex flex-col items-center gap-[20px] creator-theme">
			<span className="intro-title w-full !text-[32px] !mt-[35px] [font-family:var(--font-body)] font-semibold m-0 !text-center">
				{translate('creator', 'call_popup.modal_title')}
			</span>

			<Image
				fit="contain"
				height="170px"
				src="https://storage.googleapis.com/newo-static-files/animations/ringing%20phone.gif"
			/>

			<Button
				className="group !flex !w-full !border !border-[black] bg-white	!rounded-xl text-black !text-sm !font-medium !h-10 !pr-[22px]
								!justify-center !items-center !gap-x-2.5 hover:text-white hover:bg-black sm:border-[black]
								sm:max-w-fit sm:!text-white	sm:!bg-black sm:!w-[116px] sm:hover:!bg-white sm:hover:!text-black
								sm:hover:!border-[black]"
				onClick={handleClose}
			>
				{translate('common', 'ok')}
			</Button>
		</div>
	);
};

export default CheckYourPhone;
